module.exports = __webpack_public_path__ + "img/places.ee9ee6f9.svg";